<template>
  <div class="cfa-root">
    <c-f-a-nav :alert="alertString">
      <template v-slot:title>
        <div class="w-100 pt-2 text-start mt-0 mb-0 camp-detail-head">
          <h1
            class="cfa-section-title"
            style="
              color: white;
              font-weight: 300;
              margin-top: 20px;
              margin-bottom: 50px;
              margin-left: 40px;
            "
          >
            {{ $t("micro-learning.details.title") }}
          </h1>
          <h2 style="color: white; margin-left: 40px">
            {{ $t("micro-learning.details.report_title") }}:
            <span class="">{{ allModules.name }}</span>
          </h2>
          <div
            style="display: flex; justify-content: flex-end; margin-left: 30px"
          >
            <button
              class="btn cfa-btn-primary mx-1 ml-2"
              @click="getCampaignReport()"
            >
              <i class="fa fa-download white-color"></i>
              <span class="ml-3">{{
                $t("micro-learning.details.generate_report")
              }}</span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:content>
        <div v-if="!waitingAPIResponse" class="cfa-page">
          <div class="tab mt-1">
            <div class="tab-body" style="margin-bottom: 1em; border: none">
              <div
                class="row pt-3 mt-2"
                style="margin: auto; display: flex; justify-content: space-evenly"
              >
                <div class="col-md-3 details">
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    Chat envoyé
                  </h6>
                  <h5
                    style="
                      color: #06bbc4;
                      font-size: 24px;
                      margin-top: 30px;
                      text-align: center;
                    "
                  >
                    {{ templateData.total_sent }}
                  </h5>
                </div>
                <div class="col-md-3 details">
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    Chats ouverts
                  </h6>
                  <h5
                    style="
                      color: #f7a92b;
                      font-size: 24px;
                      margin-top: 30px;
                      text-align: center;
                    "
                  >
                    {{ templateData.total_opened }}
                  </h5>
                </div>
                <div class="col-md-3 details">
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    {{ $t("micro-learning.details.visualisation") }}
                  </h6>
                  <h5
                    style="
                      color: #ff2836;
                      font-size: 24px;
                      margin-top: 30px;
                      text-align: center;
                    "
                  >
                    {{ templateData.total_viewed }}
                  </h5>
                </div>
              </div>
              <div
                class="row pt-3 mt-4"
                style="
                  background-color: #fff;
                  display: flex;
                  justify-content: space-evenly;
                  max-width: 1200px;
                  margin: auto;
                "
              >
                <div class="col-md-3 details text-center">
                  <DoughnutChart
                    :classValue="'chartTextStyle3'"
                    :width="100"
                    :height="100"
                    :valueCountUp="true"
                    :percent="
                      allModules?.percentage_message_sent?.toString() || '0'
                    "
                    :percent-to-display="
                      allModules?.percentage_message_sent?.toString() || '0'
                    "
                    :visibleValue="true"
                    foregroundColor="#06BBC4"
                    backgroundColor="#E6F8F9"
                    :strokeWidth="30"
                  />
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    Chat envoyé
                  </h6>
                </div>
                <div class="col-md-3 details text-center">
                  <DoughnutChart
                    :classValue="'chartTextStyle3'"
                    :width="100"
                    :height="100"
                    :valueCountUp="true"
                    :percent="templateData?.open_rate?.toString().substring(0, 3)"
                    :percent-to-display="
                      templateData?.open_rate?.toString().substring(0, 3)
                    "
                    :visibleValue="true"
                    foregroundColor="#F7A92B"
                    backgroundColor="#FEF6EA"
                    :strokeWidth="30"
                  />
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    Chats ouverts
                  </h6>
                </div>
                <div class="col-md-3 text-center">
                  <DoughnutChart
                    :classValue="'chartTextStyle3'"
                    :width="100"
                    :height="100"
                    :valueCountUp="true"
                    :percent="templateData?.view_rate?.toString().substring(0, 3)"
                    :percent-to-display="
                      templateData?.view_rate?.toString().substring(0, 3)
                    "
                    :visibleValue="true"
                    foregroundColor="#FF2836"
                    backgroundColor="#FFEAEB"
                    :strokeWidth="30"
                  />
                  <h6
                    style="
                      font-size: 15px;
                      font-weight: 50;
                      margin-top: 20px;
                      text-align: center;
                    "
                  >
                    {{ $t("micro-learning.details.visualisation") }}
                  </h6>
                </div>
              </div>

              <div
                class="row pt-3 mt-5"
                style="
                  background-color: #fff;
                  border-radius: 6px;
                  margin: auto;
                  max-width: 1200px;
                "
              >
                <div>
                  <Table
                    :hide-control="campaignsAll.length == 0 ? true : false"
                    :i="4"
                    :columns="users"
                    :data="campaignsAll"
                    :customized-default-image="true"
                    :last-cell-width="0"
                  >
                    <template v-slot:defaultImage>
                      <img
                        src="@/assets/img/gif/campagne.gif"
                        alt="empty content"
                        style="width: 11em"
                      />
                      <span class="mt-3 fs-5 fw-bold pl-2 text-center empty-label">{{
                        $t("micro-learning.details.no_save")
                      }}</span>
                    </template>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="waitingAPIResponse" class="cfa-page">
          <div
            class="d-flex justify-content-center align-items-center"
            style="min-height: 70vh"
          >
            <div class="loader-pulse">
              <div class="logo-placeholder">
                <img
                  src="../../assets/brand/cfa-favicon1.png"
                  alt="cfa preloader"
                />
                <span class="loader-text">{{ $t("loading") }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </c-f-a-nav>
    <c-f-a-footer></c-f-a-footer>
  </div>
</template>

<script>
import CFANav from "@/components/nav/CFANav.vue";
import CFAFooter from "@/components/nav/CFAFooter.vue";
import Table from "@/components/shared/table/Table.vue";
import DoughnutChart from "@/components/shared/chart/DoughnutChart.vue";
import { getAPI } from "@/axios-api";

export default {
  name: "CampaignDetailsTeams",
  components: {
    DoughnutChart,
    Table,
    CFAFooter,
    CFANav,
  },
  data() {
    return {
      minDate: new Date(),
      minDateEnd: new Date(),
      waitingAPIResponse: true,
      waitingAPIResponse2: true,
      serviceAllData: [],
      newCampaignTitle: "",
      newcampaignUpdate: false,
      newCampaignSmsSenderName: "",
      newCampaignEmailSenderName: "",
      isConnected: true,
      alertString: null,
      currentTab: localStorage.tab_phish_active || "campaign_activate",
      newCampaigndefaultmsg: "",
      campaignsAll: [],
      campaignsAllOk: [],
      campaignsAllColumns: ["n°", "Nom", "Campaign Type", "Date création", "Actions"],
      campaignsAllToListen: ["Actions"],
      campaignByid: [],
      groupAll: [],
      groupAllColumns: ["n°", "Nom", "Utilisateurs", "Denière modification", "Actions"],
      groupAllToListen: ["Actions"],
      microlearning: [],
      allModules: [],
      reportsAll: [],
      users: [
        this.$t("micro-learning.details.table.name"),
        this.$t("micro-learning.details.table.email"),
        this.$t("micro-learning.details.table.status"),
        this.$t("micro-learning.details.table.sending_date"),
        this.$t("micro-learning.details.table.open_date"),
        this.$t("micro-learning.details.table.sensitized"),
      ],
      reportsAllColumns: ["n°", "Campagne", "Utilisateurs", "Actions"],
      reportsAllToListen: ["Actions"],
      newCampaignEmailSignature: "",
      userGroupAll: [],
      userGroupAllColumns: ["Nom", "Prénoms", "Email", "Position", "Actions"],
      userGroupAllToListen: ["Actions"],
      newCampaignSmsSignature: "",
      openDeletionBox: false,
      tempDeleteID: null,
      tempDeleteName: null,
      updateGroupPayload: null,
      openUpdateGroup: false,
      name_check: null,
      callbackPayload: null,
      exitOrgModalDel: null,
      exitOrgUpdateModal: null,
      newFirstname: null,
      newLastname: null,
      newEmail: null,
      newPosition: null,
      newCampaignService: "",
      openDeletionCampaignBox: false,
      newCampaignForm: false,

      newCampaignName: null,
      newCampaignType: "default",
      newCampaignDateStart: null,
      newCampaignDateEnd: null,
      newCampaignGroupe: null,
      newCampaignEmailTemplate: null,
      newCampaignLandingTemplate: null,
      newCampaignTarget: "",
      currentTabIndex: 0,
      userList: [],
      selectedUser: [],
      credit_mail: "•••",
      credit_sms: "•••",
      total_credit_mail: "•••",
      total_credit_sms: "•••",
      openNewGroup: false,
      exitNewGroupModal: null,
      updateGroupData: {},
      updateGroupStatusRequest: true,
      flattenedIds: [],
      exitGroupUpdateModal: null,
      groupAllData: [],
      totalModule: 0,
      groupeApiWaiting: false,
      groupApiWaitingData: [],
      groupeApiTemplateWaiting: false,
      groupApiTemplateWaitingData: [],
      defaultImage: " /images/defaultImage.png",
      waitingAPITemplate: true,
      waitingAPITemplate2: true,
      email1: "",
      email2: "",
      templateData: [],
      currentTemplateIndex: 0,
      currentTemplate: null,

      templateData1: [],
      currentTemplateIndex1: 0,
      currentTemplate1: null,

      templateChoosed: "",
      pageChoosed: "",
      privacyCheck: null,
      campaignWaiting: [],

      subscriptionData: [],
    };
  },
  methods: {
    retrieveUserSubscription() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`subscriptions/find-subscription`)
        .then((response) => {
          if (response.status == 200) {
            this.subscriptionData = response.data.data;

            if (this.subscriptionData != null) {
              console.log("Infos: ", this.subscriptionData);
            }

            this.remain_days = this.subscriptionData.remain_days;

            const created_at = new Date(this.subscriptionData.created_at);
            created_at.setDate(created_at.getDate() + 30);

            const expirationDate = created_at.toISOString();

            this.expiration_date = expirationDate;
          } else {
            console.log("Subslength: ", this.subscriptionData.length);
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch(() => {
          this.waitingAPIResponse = false;
        });
    },
    updatePrivacyCheck() {
      this.privacyCheck = !this.privacyCheck;
    },
    selectAll() {
      this.selectedUser = this.userList.map((user) => user.id);
    },
    selectTab(section) {
      localStorage.setItem("tab_phish_active", section);
      this.currentTab = section;
    },
    convertDate(dateString, dateOnly = false) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString();
      const formattedTime = date.toLocaleTimeString();
      if (!dateOnly) {
        return `<b>${formattedDate} à ${formattedTime}</b>`;
      }
      return `<b>${formattedDate}</b>`;
    },
    getAllModule() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`micro_learning/campaigns/${this.$route.params.id}/`)
        .then((response) => {
          if (response.status == 200) {
            let modulesData = response.data;
            this.tempDeleteID = modulesData.id;
            this.allModules = modulesData;
            this.totalModule = modulesData.count;
            this.totalInProgress = 1;
          } else {
            let msg = "Oups ! something went wrong.";
            this.alertString = `${msg}|alert-no|5000::` + Date.now();
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            let firstError = Object.values(error.response.data)[0][0];
            this.alertString = `${firstError}|alert-no|10000::` + Date.now();
          } else if (error.request) {
            let msg =
              "The request was made but no response was received. Please check your network.";
            this.alertString = `${msg}|alert-no|8000::` + Date.now();
          } else {
            let msg = "Oups ! something went wrong.";
            this.alertString = `${msg}|alert-no|5000::` + Date.now();
          }
          this.waitingAPIResponse = false;
        });
    },
    getCampaignReport() {
      if (
        this.allModules.status == "In Progress" ||
        this.allModules.status == "Unavailable" ||
        this.allModules.status == "created"
      ) {
        this.$swal({
          title: "Attention",
          text: "Le rapport ne peut être généré que pour les campagnes terminées",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
      getAPI
        .get(`micro_learning/campaign/report/${this.tempDeleteID}/`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        })
        .then((response) => {
          this.waitingAPIResponse = false;
          if (response.status == 200) {
            try {
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.allModules.name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            } catch (error) {
              console.error("Error creating or downloading file:", error);
              let msg = "Error downloading file. Please try again.";
              this.alertString = `${msg}|alert-no|5000::${Date.now()}`;
            }
          }
          if (response.status === 403) {
            let msg =
              "Le rapport ne peut être généré que pour les campagnes terminées";
            this.alertString = `${msg}|alert-warning|10000::${Date.now()}`;
          }
        })
        .catch((error) => {
          this.waitingAPIResponse = false;
          if (error.response) {
            if (error.response.status === 403) {
              let msg =
                "Le rapport ne peut être généré que pour les campagnes terminées";
              this.alertString = `${msg}|alert-warning|10000::${Date.now()}`;
            } else {
              this.alertString = `${this.$t(
                "micro-learning.details.report_error"
              )}|alert-no|10000::${Date.now()}`;
            }
          } else if (error.request) {
            let msg =
              "The request was made but no response was received. Please check your network.";
            this.alertString = `${msg}|alert-no|8000::${Date.now()}`;
          } else {
            let msg = "Oups ! something went wrong.";
            this.alertString = `${msg}|alert-no|5000::${Date.now()}`;
          }
        });
    },
    getAllMicroLearning() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`micro_learning/ms-teams-campaign-records/`, {
          params: { campaign: this.$route.params.id },
        })
        .then((response) => {
          if (response.status == 200) {
            this.campaignsAll = [];
            let data = response.data.results;
            this.microlearning = response.data.results;
            for (let i = 0; i < data.length; i++) {
              let row = data[i];

              this.campaignsAll.push({
                [this.$t("micro-learning.details.table.name")]: `<span class="selectable">${row.user_first_name}   ${row.user_last_name}</span>`,
                [this.$t("micro-learning.details.table.email")]: `<span class="selectable" style="text-transform: lowercase;" >${row.user_email}</span>`,
                [this.$t("micro-learning.details.table.status")]: `${
                  row.status == "failed"
                    ? `<span class="badge rounded-pill badge-danger cfa-bg-secondary mw-status">échoué</span>`
                    : row.status == "success"
                    ? `<span class="badge rounded-pill badge-warning cfa-bg-warning mw-status" style="background-color:#FEF6EA;color:#F8B13D;">succès</span>`
                    : ""
                }`,
                [this.$t("micro-learning.details.table.sending_date")]: this.convertDate(
                  row.created_at,
                  true
                ),
                [this.$t("micro-learning.details.table.open_date")]: `${
                  row.opening_date == null
                    ? `<span class="badge rounded-pill badge-danger  mw-status" style="background-color:#FEEAEB;color:#FF3947;">En attente</span>`
                    : row.opening_date != null
                    ? this.convertDate(row.opening_date, true)
                    : `hello`
                }`,
                [this.$t("micro-learning.details.table.sensitized")]: `${
                  row.opened == false
                    ? `<span class="badge rounded-pill badge-danger  mw-status" style="background-color:#FEEAEB;color:#FF3947;">Non</span>`
                    : row.opened == true
                    ? `<span class="badge rounded-pill badge-warning mw-status" style="background-color:#E7F9F1;color:#2ECD77;">Oui</span>`
                    : `hello`
                }`,
              });
            }
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch(() => {
          this.waitingAPIResponse = false;
        });
    },
    getTemplate() {
      this.waitingAPITemplate2 = true;
      getAPI
        .get(
          `micro_learning/campaigns/ms-teams/campaign-analytics/${this.$route.params.id}/`
        )
        .then((response) => {
          if (response.status == 200) {
            this.templateData = response.data;
            this.currentTemplate = this.templateData[this.currentTemplateIndex];
            this.templateChoosed = this.currentTemplate.id;
          }
          setTimeout(() => {
            this.waitingAPITemplate2 = false;
          }, 2000);
        })
        .catch(() => {
          this.waitingAPITemplate2 = false;
        });
    },
  },
  mounted() {
    this.getAllModule();
    this.retrieveUserSubscription();
    this.getAllMicroLearning();
    this.getTemplate();
  },
};
</script>

<style scoped>
.camp-detail-head {
  background-size: cover;
  background-repeat: no-repeat;
  height: 250px;
}
.details {
  background-color: #fff;
  height: 150px;
  border-radius: 10px;
}
</style>

